import { render, staticRenderFns } from "./EmployeeAdd.vue?vue&type=template&id=7f84fa97&scoped=true"
import script from "./EmployeeAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeAdd.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAdd.vue?vue&type=style&index=0&id=7f84fa97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84fa97",
  null
  
)

export default component.exports